export const listingInfo = state => state.FloatingCart.listingInfo;
export const faxLineInfo = state => state.FloatingCart.faxLineInfo;
export const lines = state => state.FloatingCart.lines;
export const serviceName = state => state.FloatingCart.phoneServiceInfo.serviceName;
export const price = state => state.FloatingCart.phoneServiceInfo.price;
export const equipments = state => state.FloatingCart.equipments;
export const tvPlan = state => state.FloatingCart.tvPlan;
export const premChannels = state => state.FloatingCart.premChannels;
export const tvEquip = state => state.FloatingCart.tvEquip;
export const tvRec = state => state.FloatingCart.tvRec;
export const internetPlan = state => state.FloatingCart.internetPlan;
export const internetIP = state => state.FloatingCart.internetIP;
export const getCartInfoSuccessResponse = state => state.ReviewOrderPage.getCartInfoSuccessResponse;
export const getFloatCartResponse = state => state.CustomizeOrder.getFloatCartResponse;
export const internet = state => state.FloatingCart.internet;
export const phone = state => state.FloatingCart.phone;
export const tv = state => state.FloatingCart.tv;
export const voice = state => state.FloatingCart.voice;
export const isWinbackSelected =  state => state.FloatingCart?.phone?.BdvPhoneLines;
export const BDVInfoResponse = (state) => state.CustomizeOrder.customizeProductsResponse?.BDVInfo;
export const DoLoopDataInfo = (state) => state.AddressValidationPage.addressQualificationDetails.DataInfo;
export const standaloneTvFlowDataRes = (state) => state.CustomizeOrder.standaloneTvFlowDataRes;
export const internetRouterList = (state) => state.CustomizeOrder.internetRouterList;
export const servicesInCart = (state) => state.CustomizeOrder.servicesInCart;
export const getPostLqData = state => state.CustomizeOrder.getPostLqData;
export const selectedStaticIPId = (state) => state.CustomizeOrder.selectedStaticIPId;
